import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs',
  standalone: false
})
export class AbsPipe implements PipeTransform {
  transform(value: number): number {
    // Si no es un número válido, devolvemos 0 para evitar errores en el HTML
    if (isNaN(value)) return 0; 
    
    return Math.abs(value);
  }
}